var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInternet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "internet"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.418 57.346C45.3372 57.346 57.4316 45.2515 57.4316 30.3323C57.4316 15.4131 45.3372 3.31863 30.418 3.31863C15.4987 3.31863 3.4043 15.4131 3.4043 30.3323C3.4043 45.2515 15.4987 57.346 30.418 57.346Z",
    stroke: "#141414",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30.4168 57.346C36.3845 57.346 41.2223 45.2515 41.2223 30.3323C41.2223 15.4131 36.3845 3.31863 30.4168 3.31863C24.4491 3.31863 19.6113 15.4131 19.6113 30.3323C19.6113 45.2515 24.4491 57.346 30.4168 57.346Z",
    stroke: "#141414",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.4043 30.3362H57.4316",
    stroke: "#141414",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternet);
export default __webpack_public_path__ + "static/media/Internet.1b9485a5ce833dda5c0a9d7cca1e7f78.svg";
export { ForwardRef as ReactComponent };